import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { ParallaxProvider } from "react-scroll-parallax"
import { registerLicense } from "@syncfusion/ej2-base"

import { Provider } from "react-redux"
import store from "./redux/store"

import "./index.css"
import App from "./App"

registerLicense(
  "ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkxhW39Yc3ZXTmlVWUQ=",
)

const container = document.getElementById("root")
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <ParallaxProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ParallaxProvider>
  </Provider>,
)
